import { render, staticRenderFns } from "./AnalyticsPortfolio.vue?vue&type=template&id=5bd04cc0&scoped=true&"
import script from "./AnalyticsPortfolio.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsPortfolio.vue?vue&type=style&index=0&id=5bd04cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd04cc0",
  null
  
)

export default component.exports